import { Dialog } from '@mui/material';
import styled from 'styled-components';
import { Box } from '@mui/material';
import { Button, Typography } from '@leapeasy/ui-kit';
import { resolveProfileAvatarFallback, resolveProfileAvatarSrc } from 'data/images/avatars';

export const LogoutModal = ({ open, onClose, onConfirm, userImage }) => {
  const avatarSrc = resolveProfileAvatarSrc(userImage);
  const avatarFallback = resolveProfileAvatarFallback(userImage);

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth={false}>
      <Container>
        <UserIconWrap>
          <img
            src={avatarSrc}
            alt="User avatar"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = avatarFallback;
            }}
          />
        </UserIconWrap>

        <Content>
          <TextBlock>
            <Title variant="body1">Are you sure you want to log out?</Title>

            <Description>
              You’ll be signed out of your account and will need to log in again to continue.
            </Description>
          </TextBlock>

          <Actions>
            <DiscardButton variant="tertiary" size="medium" onClick={onClose}>
              Stay logged in
            </DiscardButton>
            <LogoutButton variant="primary" size="medium" onClick={onConfirm}>
              Log out
              <LogoutArrow viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 12h12" />
                <path d="m13 6 6 6-6 6" />
              </LogoutArrow>
            </LogoutButton>
          </Actions>
        </Content>
      </Container>
    </StyledDialog>
  );
};

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    margin: 0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: none;
    background: transparent;
    width: min(351px, calc(100vw - 24px));
    max-width: calc(100vw - 24px);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 24px 20px 20px;
  background: #fff;
  border: 1px solid #f3f3f3;
  box-shadow:
    0px 16px 32px -4px rgba(90, 94, 107, 0.04),
    0px 2px 4px rgba(90, 94, 107, 0.08);
  border-radius: 8px;
  box-sizing: border-box;
  width: 100%;
  min-height: 291px;
`;

const UserIconWrap = styled.div`
  width: 100px;
  height: 100px;
  overflow: hidden;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 311px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;

const TextBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

const Title = styled(Typography)`
  color: #2e0f40;
  font-weight: 600 !important;
  text-align: center;
  font-size: 14px !important;
  line-height: 165% !important;
  letter-spacing: -0.14px;
`;

const Description = styled.p`
  margin: 0;
  width: 100%;
  max-width: 311px;
  color: #6a5e71;
  opacity: 0.9;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 165%;
  text-align: center;
`;

const Actions = styled(Box)`
  display: flex;
  gap: 16px;
  width: 100%;
`;

const DiscardButton = styled(Button)`
  flex: 1;
  min-width: 0;
  min-height: 40px;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  color: #6a5e71;
`;

const LogoutButton = styled(Button)`
  flex: 1;
  min-width: 0;
  min-height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const LogoutArrow = styled.svg`
  width: 20px;
  height: 20px;
  stroke: #ffffff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
`;
